import React from "react";
import { twMerge } from "tailwind-merge";

import type { Styled } from "~/utils";

export const Spinner = ({ className }: Styled) => {
  return (
    <div
      className={twMerge(
        "h-12 w-12 animate-spin rounded-full border-4 border-neutral-60 border-t-neutral-98",
        className,
      )}
    />
  );
};
